import Axios from 'axios';

import { ClearAuth } from '../actions/Auth';

import { store } from '../config/configureStore';
import Localization from '../config/localization';

import { GetError } from '../lib/error';
import { ToString } from '../lib/utils';

const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*'
  }
});

axios.interceptors.request.use(
  config => {
    const state = store.getState();

    if (state && state.Auth && state.Auth.token) {
      config.headers['EON-FAST-USER-TOKEN'] = state.Auth.token;
    }

    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  response => {
    return response;
  },
  async error => {
    let errorData = (error && error.response && error.response.data) || new Error();

    if (errorData instanceof Blob) {
      errorData = await new Promise((resolve, reject) => {
        const reader = new FileReader();

        reader.addEventListener('error', reject);
        reader.addEventListener('loadend', () => resolve(JSON.parse(ToString(reader && reader.result) || '{}')));

        reader.readAsText(errorData);
      });
    }

    const responseError = GetError(errorData);

    if (ToString(responseError.code) === '401' && responseError.message === Localization.Errors['401']) {
      store.dispatch(ClearAuth());
    }

    return Promise.reject(responseError);
  }
);

export default axios;
